import { request } from '../http/index';
// eslint-disable-next-line camelcase
export function uploadAvatar(data, _selected_student_, _productId) {
  return request({
    url: '/metis-atlas-account/api/avatar/upload',
    method: 'POST',
    data: data,
    params: {
      _productId: _productId,
      // eslint-disable-next-line camelcase
      _selected_student_: _selected_student_
    },
    customErr: true
  });
}
export function getDataDictAll() {
  return request({
    url: '/metis-data-dict/api/all',
    method: 'GET'
  });
}